export default "__VITE_ASSET__BN8bRbjL__"